import tw from "twin.macro";

export const Container = tw.div`relative bg-customGreyLight `;
export const ContentWithPaddingXl= tw.div`max-w-screen-4xl mx-auto py-20 lg:py-24 font-poppins px-2`;
export const ContentWithPaddingLg= tw.div`max-w-screen-lg mx-auto py-20 lg:py-24`;
export const ContentForServices= tw.div`max-w-screen-3xl mx-auto py-20 lg:py-24`;

export const ContentWithVerticalPadding = tw.div`py-20 lg:py-24`;
export const Content2Xl= tw.div`max-w-screen-2xl mx-auto`;
